import { render, staticRenderFns } from "./relationSaleLog.vue?vue&type=template&id=c49d3450&scoped=true"
import script from "./relationSaleLog.vue?vue&type=script&lang=js"
export * from "./relationSaleLog.vue?vue&type=script&lang=js"
import style0 from "./relationSaleLog.vue?vue&type=style&index=0&id=c49d3450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49d3450",
  null
  
)

export default component.exports